const getAuthHeaders = () => {
  const headers = {
    headers: {
      Authorization: `Bearer ${$('#token').val()}`
    }
  }

  const datatableHeaders = {
    Authorization: `Bearer ${$('#token').val()}`,
  }

  return {
    headers,
    datatableHeaders,
  }
}

export default getAuthHeaders;
